import { useContext } from "react";
import "./SettingsContent.css";
import { LightModeContext } from "../../../hooks/mode/LightModeContextProvider";
import { Collapse } from "react-collapse";

const ToggleSwitch = ({ checked, onChange, name, color = "#b10511" }) => (
  <label
    className="contour-toggle-label"
    data-testid={`settings-toggle-${name}`}
  >
    <input
      type="checkbox"
      className="contour-toggle-input"
      checked={checked}
      onChange={(e) =>
        onChange({ target: { checked: e.target.checked, name } })
      }
      name={name}
      data-testid={`settings-toggle-input-${name}`}
    />
    <span className="contour-toggle-track" style={{ "--toggle-color": color }}>
      <span className="contour-toggle-thumb" />
    </span>
  </label>
);

const SettingsContent = ({
  scrollZoom,
  setScrollZoom,
  dragRotate,
  setDragRotate,
  keyboard,
  setKeyboard,
  showClock,
  setShowClock,
  showCursorCoords,
  setShowCursorCoords,
  isSmallScreen,
  openSection,
}) => {
  const { toggle, isLightMode } = useContext(LightModeContext);

  const handleToggle = (event, setter) => {
    setter(event.target.checked);
  };

  const switches = (
    <>
      <div className="settings-leftside">
        <div className="switch-item">
          <p>Thème Sombre</p>
          <ToggleSwitch
            checked={!isLightMode}
            onChange={(e) => handleToggle(e, toggle)}
            name="themeSwitch"
          />
        </div>
        <div className="switch-item">
          <p>Afficher l'horloge</p>
          <ToggleSwitch
            checked={showClock}
            onChange={(e) => handleToggle(e, setShowClock)}
            name="showClock"
          />
        </div>
        <div className="switch-item">
          <p>Suivi des coordonnées</p>
          <ToggleSwitch
            checked={showCursorCoords}
            onChange={(e) => handleToggle(e, setShowCursorCoords)}
            name="showCursorCoords"
          />
        </div>
      </div>
      <div className="settings-rightside">
        <div className="switch-item">
          <p>Zoom avec molette</p>
          <ToggleSwitch
            checked={scrollZoom}
            onChange={(e) => handleToggle(e, setScrollZoom)}
            name="scrollZoom"
          />
        </div>
        <div className="switch-item">
          <p>Rotation carte</p>
          <ToggleSwitch
            checked={dragRotate}
            onChange={(e) => handleToggle(e, setDragRotate)}
            name="dragRotate"
          />
        </div>
        <div className="switch-item">
          <p>Navigation clavier</p>
          <ToggleSwitch
            checked={keyboard}
            onChange={(e) => handleToggle(e, setKeyboard)}
            name="keyboard"
          />
        </div>
      </div>
    </>
  );

  return (
    <>
      {isSmallScreen ? (
        <Collapse isOpened={openSection === "settings"}>
          <div className="settings-container">{switches}</div>
        </Collapse>
      ) : (
        <div className="settings-container">{switches}</div>
      )}
    </>
  );
};

export default SettingsContent;
